import { useCallback } from "react";
import { getOptionByIdWithCORP } from "../../api/TabwareOptions";
import { useWorkOrderStore } from "../../store/wo-order";

export default function useGetNoOfMeterHistoryDisplay() {
  const setWoNoOfMeterHistoryDisplay = useWorkOrderStore(
    (state) => state.setWoNoOfMeterHistoryDisplay
  );
  const getNoOfMeterHistoryDisplay = useCallback(async () => {
    const response = await getOptionByIdWithCORP("NoOfMeterHistoryDisplay");
    const number = response.data.PlantValue
      ? Number(response.data.PlantValue)
      : Number(response.data.DefaultValue);
    setWoNoOfMeterHistoryDisplay(isNaN(number) ? 0 : number);
  }, [setWoNoOfMeterHistoryDisplay]);

  return { getNoOfMeterHistoryDisplay };
}
